/**
 * Extracts the numeric value from a CSS value string, supporting only 'px' units.
 *
 * @param value - The CSS value as a string (e.g., '12px') or a number.
 * @returns The numeric value if parsing is successful, `undefined` if the input is undefined,
 *          or `null` if the value is not a 'px' string or cannot be parsed as a number.
 *
 * Note: Only 'px' units are supported since other values depend from context. If the value does not end with 'px', null is returned.
 *       If parsing fails, null is returned.
 */
export const extractCSSUnitNumericValue = (
  value: string | number | undefined,
): number | undefined => {
  if (typeof value === 'number') return value;
  if (value === undefined) return undefined;
  if (!value.trim().endsWith('px')) return undefined;
  const parsed = parseFloat(value);
  return isNaN(parsed) ? undefined : parsed;
};
